import React, { Fragment } from 'react';
import { withCookies } from 'react-cookie';
import stripebadge from '../assets/stripebadge.png';

import { Typography, Paper, Button } from '@material-ui/core'

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import { RestComponent, StripeManager } from 'react-frontend-utils'


/**
 * 
 * Checkout Component after Patron submits a request that requires payment 
 * 
 * The caller must pass the props:
 * 
 * type:                   the type of payment (for instance 'Booking' or 'Signup')
 * returnFromPayment:      a function to be called to leave the payment page
 * paymentDescription:     String describing the payment (for instance the amount)
 * purchaseComplete:       a function to be called when purchasing is complete
 * clientSecret:           the clientSecret retrieved from the backend from Stripe
 * email:                  pre-populate the email for the credit card
 * 
 * The StripeManager component takes care of the purchase. 
 *
 */


export class PatronCheckout extends RestComponent {

    styles = {
        paperLabel: {
            color: 'blue',
            fontSize: '12pt',
            flexGrow: 1
        }
    }
        
    render() {
        
        return (
            <Fragment>

                {this.getConfirmAlertComponent()}

                <Paper style={{padding: 20}}>

                    <Typography variant="h6" align='center' style={{marginBottom: 40}}>{this.props.paymentDescription}</Typography>                           

                    <Button color="primary" style={{marginBottom: 20}} onClick={this.props.returnFromPayment}>
                        <ArrowBackIosIcon fontSize='small'/> 
                        <Typography variant="body1">{"Cancel and Go Back to " + this.props.type}</Typography>   
                    </Button>  

                            
                    <StripeManager email={this.props.email}
                                    clientSecret={this.props.clientSecret}
                                    paymentSuccess={this.props.purchaseComplete}/>
                </Paper>

                <div style={{display: 'flex', justifyContent: 'center', marginTop: 100}}>

                    <a href="https://www.stripe.com" target="_blank" rel="noopener noreferrer">
                        {<img src={stripebadge} alt="stripe badge" width='400px'/>}
                    </a>

                </div>                

            </Fragment>
        );
    }

}

export default withCookies(PatronCheckout);
